import React, { useCallback } from 'react'
import { Button, Card, Col, Descriptions, Modal, Row, Space } from 'antd'
import { useLocation, generatePath } from 'react-router-dom'
import { AppointmentRoutes } from '../constants'
import { useBackgroundNavigate } from '@shared/hooks'

export const SimilarUsers = () => {
  const location = useLocation()
  const navigate = useBackgroundNavigate()

  const close = useCallback(() => {
    navigate(location.state?.background)
  }, [navigate, location.state?.background])

  const goToDetails = useCallback(
    (id) => {
      navigate(generatePath('/customers/:id/details', { id }), { withBackground: true })
    },
    [navigate],
  )

  const chooseCustomer = useCallback(
    (id) => {
      navigate(generatePath(AppointmentRoutes.CREATE_BY_USER_ID, { userId: id }))
    },
    [navigate],
  )

  if (!location.state?.customers || !location.state?.background) {
    return null
  }

  return (
    <Modal open={true} width={768} footer={null} onCancel={close} title='Oxşar müştərilər'>
      <Row gutter={[0, 16]}>
        {location.state?.customers.map((customer) => (
          <Col key={customer.id} span={24}>
            <Card
              title={`#${customer.id} - ${customer.firstname} ${customer.lastname} ${customer.patronymic}`}
              size='small'
              bodyStyle={{ padding: 0 }}
              extra={
                <Space size={8}>
                  <Button onClick={() => goToDetails(customer.id)}>Ətraflı</Button>
                  <Button onClick={() => chooseCustomer(customer.id)}>Seç</Button>
                </Space>
              }
            >
              <Descriptions column={2} bordered={true} size='small'>
                <Descriptions.Item label='Email'>{customer.email}</Descriptions.Item>
                <Descriptions.Item label='Telefon'>{customer.phoneNumber}</Descriptions.Item>
                <Descriptions.Item label='FİN Kod'>{customer.passport.secret}</Descriptions.Item>
                <Descriptions.Item label='Cinsi'>{customer.gender && (customer.gender === 'female' ? 'Qadın' : 'Kişi')}</Descriptions.Item>
                <Descriptions.Item label='Doğum tarixi'>{customer.createdAt}</Descriptions.Item>
                <Descriptions.Item label='Milliyəti'>{customer.nationality}</Descriptions.Item>
                <Descriptions.Item label='Yaradılma tarixi'>{customer.createdAt}</Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        ))}
      </Row>
    </Modal>
  )
}
